import * as React from 'react';
import { observer } from 'mobx-react';
import { LoadingSpinner, SavingIndicator, SavingIndicatorStatus } from '../../indicator/index';
import { IMakeModelYearSuggestion } from '../../../../../common/interfaces/search';
import * as classNames from 'classnames';

// Styles
const s = require('./MakeModelYearAutocomplete.css');
const closeIcon = require('./../../../assets/cross-orange-sign.svg');

// Props
interface IMakeModelYearAutocompleteProps {
    onDismissClick: () => void;
    onSuggestionClick: (suggestion: IMakeModelYearSuggestion) => void;
    onLoadMoreClick: () => void;
    suggestionOnFocus: number | null;
    suggestions: IMakeModelYearSuggestion[];
    showLoadMore: boolean;
    focusOnLoadMore: boolean;
    loading: boolean;
    show: boolean;
    showDuration: number;
}

// Component
@observer
export class MakeModelYearAutocomplete extends React.Component<IMakeModelYearAutocompleteProps, {}> {
    constructor(props: IMakeModelYearAutocompleteProps) {
        super(props);

        this.scrollToFocusedEntry();
    }

    componentDidUpdate(prevProps: IMakeModelYearAutocompleteProps) {
        if (
            prevProps.focusOnLoadMore !== this.props.focusOnLoadMore ||
            prevProps.suggestionOnFocus !== this.props.suggestionOnFocus
        ) {
            this.scrollToFocusedEntry();
        }
    }

    public render() {
        return (
            <div
                ref={this.referenceSuggestionsList}
                className={classNames(s.suggestions, {
                    [s.show]: this.props.show
                })}
            >

                <div className={s.label}>
                    <button onClick={this.handleDismissSuggestions}>
                        <p>Suggestions</p>
                        <span>Close suggestions</span>
                        <img src={closeIcon} alt="" />
                    </button>
                </div>

                {this.props.suggestions.map((suggestion, suggestionIndex) => {
                    const name =
                        suggestion.make + ' ' +
                        suggestion.model + ' ' +
                        suggestion.fromYear + ' - ' +
                        suggestion.toYear;

                    return (
                        <button
                            key={name}
                            onClick={this.handleSuggestionClick(suggestion)}
                            className={classNames(s.suggestion, {
                                [s.focus]: suggestionIndex === this.props.suggestionOnFocus
                            })}
                        >
                            {name}
                        </button>
                    );
                })}

                {(this.props.loading) && (
                    <div className={s.loading}>
                        <SavingIndicator
                            align="left"
                            status={SavingIndicatorStatus.Saving}
                            labels={{ saving: 'Loading...' }}
                        />
                    </div>
                )}
            </div>
        );
    }

    private suggestionsList: HTMLDivElement = null;
    private referenceSuggestionsList = (ref) => this.suggestionsList = ref;

    private showMoreButton: HTMLButtonElement = null;
    private referenceShowMoreButton = (ref) => this.showMoreButton = ref;

    private scrollToFocusedEntry = () => {
        let offsetTop: number = 0;

        if (this.props.focusOnLoadMore && this.showMoreButton) {
            offsetTop = this.showMoreButton.offsetTop;
        } else if (this.props.suggestionOnFocus !== null && this.suggestionsList) {
            const buttons = this.suggestionsList.getElementsByTagName('button');
            if (typeof buttons[this.props.suggestionOnFocus] !== 'undefined') {
                offsetTop = buttons[this.props.suggestionOnFocus].offsetTop;
            }
        }

        if (this.suggestionsList && typeof this.suggestionsList.offsetTop !== 'undefined') {
            this.suggestionsList.scrollTo(0, offsetTop);
        }
    }

    private handleDismissSuggestions = () => {
        this.props.onDismissClick();
    }

    private handleSuggestionClick = (suggestion: IMakeModelYearSuggestion) => (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onSuggestionClick(suggestion);
    }

    private handleLoadMoreClick = () => {
        this.props.onLoadMoreClick();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/PortalSearchBar/MakeModelYearAutocomplete.tsx